
class BundleProduct extends HTMLElement {
  constructor() {
    super();
    this.selectedValues = [];
    this.variantData = {};
    this.configured = false;
    this.setOrderDisplay(this.order);
    this.setAvailableOptions();
    this.addEvents();
  }

  set co2(co2) {
    this.co2 = co2;
  }

  get co2() {
    return parseInt(this.querySelector("[co2-footprint]")?.textContent);
  }

  set variantData(variantData) {
  }

  get variantData() {
    let varId = null;
    let varAvailable = false;
    let firstAvailableVariant, foundFirstAvailableVariant = false;

    this.querySelectorAll("#product-variant-ids option").forEach((opt) => {
      let productVariantNrs = ["V1", "V2", "V3", "V4", "RPK"];
      const supportsProdVersions = productVariantNrs.some(prodV => opt.textContent?.includes(prodV));

      if (supportsProdVersions) {
        variantVersionLoop:
        for (const productVariantNr of productVariantNrs) {
          let selectedValues = productVariantNr + " / " + this.selectedValues[0] + " / " + this.selectedValues[1];
          if (selectedValues.trim() == opt.textContent.trim()) {
            varId = opt.value;
            varAvailable = opt.getAttribute("available") === "true" ? true : false;
            if (varAvailable && !foundFirstAvailableVariant) {
              foundFirstAvailableVariant = true;
              firstAvailableVariant = { id: varId, available: varAvailable };
              break variantVersionLoop;
            }
          }
        }
      } else {
        let selectedValues = this.selectedValues[0] + " / " + this.selectedValues[1];
        if (selectedValues.trim() == opt.textContent.trim()) {
          varId = opt.value;
          varAvailable = opt.getAttribute("available") === "true" ? true : false;
          if (varAvailable && !foundFirstAvailableVariant) {
            foundFirstAvailableVariant = true;
            firstAvailableVariant = { id: varId, available: varAvailable };
          }
        }
      }
    });
    return firstAvailableVariant || { id: varId, available: varAvailable };
  }

  set productId(productId) {
    this.setAttribute('prod-id', productId);
  }

  get productId() {
    return this.getAttribute("prod-id");
  }

  set order(order) {
    this.setAttribute("order", order);
  }

  get order() {
    return this.getAttribute("data-order");
  }

  get selectors() {
    return this.querySelectorAll("custom-select");
  }

  setAvailableOptions() {
    //get variant ids and availability
    const productVariantOptions = Array.from(this.querySelectorAll("#product-variant-ids option"));
    const productVariantInfo = productVariantOptions.map(
      productVariantOption =>
        [
          productVariantOption.textContent,
          productVariantOption.getAttribute("available")
        ]
    );

    //get all selectors, all options, and compare with the availability array combinations;
    let productSelectors = [];
    this.selectors.forEach(selector => { productSelectors.push(selector.options) });

    // remove duplicates
    let uniqueOptionTexts = {};
    productSelectors.forEach(selector => {
      selector.forEach(option => {
        var text = option.textContent;
        if (uniqueOptionTexts[text]) {
          option.style.display = "none";
        } else {
          uniqueOptionTexts[text] = true;
        }
      })
    })

    productSelectors.forEach((selector, selectorIndex) => {
      selector.forEach(option => {
        let optionAvailability;

        if (selectorIndex != 0 && this.selectedValues[0] != null) {
          option.setAttribute("available", "false");
        }

        productVariantInfo.forEach(variant => {
          let productVersionNrs = ["V1", "V2", "V3", "V4", "RPK"];
          const supportsProdVersions = productVersionNrs.some(prodV => variant[0]?.includes(prodV));

          if (supportsProdVersions) {
            variantVersionLoop:
            for (const productVariant of productVersionNrs) {
              let selectedValues = productVariant + " / " + this.selectedValues[0] + " / ";
              if (variant[0].includes(selectedValues + option.textContent)) {
                optionAvailability = variant[1];
                if (variant[1] == 'true') {
                  option.setAttribute("available", optionAvailability);
                  break variantVersionLoop;
                }
              }
            }
          } else {
            let selectedValues = this.selectedValues[0] + " / ";
            if (variant[0].includes(selectedValues + option.textContent)) {
              optionAvailability = variant[1];
              if (variant[1] == 'true') {
                option.setAttribute("available", optionAvailability);
              }
            }
          }
        })
      })
    })
  }

  setOrderDisplay(order, color, configured) {
    this.querySelector("[order-display] .color-swatch").textContent = order;
    color && this.querySelector("[order-display]").setAttribute("data-color", color);
    configured && this.querySelector("[order-display] [success-checkmark]").classList.remove('hidden');
  }

  addEvents() {
    let _this = this;
    this.selectors.forEach(selector => {
      selector.addEventListener("click", function () {
        _this.checkConfigured();
        _this.setAvailableOptions();
        _this.setConfiguredDisplay();
      })
    });
  }

  checkConfigured() {
    let allSelectorsChosen = true;
    this.selectedValues = [];

    this.selectors.forEach(selector => {
      if (selector.getAttribute("value") == null) {
        allSelectorsChosen = false;
      } else {
        this.selectedValues.push(selector.getAttribute("value"));
      }
    })
    if (allSelectorsChosen) {
      if (this.variantData.available == true) {
        this.configured = true;
        this.querySelector("[error-variant-unavailable]").classList.add("hidden");
        this.color = this.querySelector(".select-selected").getAttribute('data-color');
      } else {
        this.querySelector("[error-variant-unavailable]").classList.remove("hidden");
      }
    }

    this.parentNode.checkAddToCart();
  }

  setConfiguredDisplay() {
    if (this.configured) {
      this.setOrderDisplay("", this.color, true);
      this.classList.add("configured");
      this.setAttribute("configured", '');
    } else {
      this.setOrderDisplay(this.order);
    }
  }

}

class BundleSelector extends HTMLElement {

  constructor() {
    super();
    this.addToCartBtn = this.parentElement.querySelector('button[name="add-bundle"]');
    this.addToCartBtn.querySelector("span").textContent = this.addToCartBtn.dataset.initialText;
    this.checkAddToCart();
  }

  set configuredBundles(configuredBundles) {
  }

  get configuredBundles() {
    return this.querySelectorAll("bundle-product[configured]");
  }

  addProductListToCart(atcBtn, productsToAdd) {
    const _this = this;
    const cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");

    if (productsToAdd.items.length >= 1) {
      atcBtn.setAttribute("disabled", "");
      atcBtn.querySelector("span").textContent = "Adding...";
      productsToAdd.sections = cart.getSectionsToRender().map((section) => section.id);
      productsToAdd.sections_url = window.location.pathname;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(productsToAdd)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          atcBtn.removeAttribute("disabled", "");
          atcBtn.querySelector("span").textContent = atcBtn.dataset.successText;

          //close modal
          document.querySelector("modal-popup.configure_bundle-modal").modalClose();

          //cart

          cart.setActiveElement(document.activeElement);
          setTimeout(() => { cart.renderContents(data) });
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          setTimeout(() => {
            cart.open();
            atcBtn.querySelector("span").textContent = atcBtn.dataset.initialText;
          }, 400);

          if (data.status == 422) {
            _this.parentElement.querySelector("[error-cart]").textContent = data.description;
          }
        })
        .catch((err) => {
        });
    }
  }

  atcHandler(e) {
    e.preventDefault();

    //FIXME: pass correct this
    const _this = document.querySelector("bundle-selector");
    const configuredBundles = _this.configuredBundles;

    let productsToAdd = { 'items': [] };
    for (let bundleProduct of configuredBundles) {
      let productObj = {
        "id": bundleProduct.variantData.id,
        "quantity": 1,
        "properties": {
          item_co2: bundleProduct.co2 || 0
        }
      }
      if (productsToAdd.items.length > 0 && productsToAdd.items.filter(y => y.id === bundleProduct.variantData.id).length > 0) {
        productsToAdd.items.find(y => y.id === bundleProduct.variantData.id).quantity++;
      } else {
        productsToAdd.items.push(productObj);
      }
    }

    _this.addProductListToCart(this, productsToAdd);
  }

  addCartEvent() {
    this.addToCartBtn.removeEventListener("click", this.atcHandler);
    this.addToCartBtn.addEventListener("click", this.atcHandler);
  }

  checkAddToCart() {
    let allConfigured = true;
    this.querySelectorAll("bundle-product").forEach(product => {
      if (product.configured == false) allConfigured = false;
      if (product.variantData.available == false) allConfigured = false;
    })

    if (allConfigured) {
      this.addToCartBtn.removeAttribute("disabled");
      this.addCartEvent();
    } else {
      this.addToCartBtn.setAttribute("disabled", '');
    }
  }
}

customElements.define('bundle-product', BundleProduct)
customElements.define('bundle-selector', BundleSelector)